<template>
  <div class="card shadow p-3">
    <div class="card-header border-0">
      <base-title :title="title" popover="Listado de ticket de soporte"></base-title>
    </div>

    <b-row>
      <b-col md="12" class="table-responsive">
        <b-table
          class="align-items-center table-flush tablesorter table-text"
          hover
          :items="tableData.data"
          :fields="columns"
          :per-page="perPage"
          :current-page="currentPage"
          :busy="
            !Array.isArray(tableData.data) || tableData.data.length === 0
              ? true
              : false
          "
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <span class="h2 text-danger">{{ $t("fail") }}</span>
            </div>
          </template>
          <template v-slot:cell(name)="data">
            {{ data.item.user.name }} {{ data.item.user.lastname }}
          </template>

          <template v-slot:cell(created_at)="data">
            {{ new Date(data.item.created_at).toLocaleDateString() }}
          </template>
          <template v-slot:cell(actions)="data">
            <b-button
              variant="info"
              size="sm"
              @click="modalsDetails(data.item)"
              v-b-tooltip.hover
              :title="$t('show')"
              ><i class="far fa-eye"></i
            ></b-button>
          </template>
        </b-table>
        <b-pagination
          class="mt-3"
          v-model="tableData.current_page"
          :total-rows="tableData.total"
          :per-page="tableData.per_page"
          :page-count="tableData.per_page"
          @input="changePage"
          first-number
          pills
          size="sm"
          align="center"
        ></b-pagination>
      </b-col>
    </b-row>
    <div>
      <b-modal id="show-ticket" :title="title">
        <template #modal-header>
          <h4>{{ title }}</h4>
          <b-button
            size="sm"
            variant="outline-light"
            class="ml-auto"
            @click="$bvModal.hide('show-ticket')"
          >
            <i class="fas fa-times"></i>
          </b-button>
        </template>

        <b-row v-if="dataModals" class="table-text">
          <b-col :md="5">
            <b-avatar
            button
              variant="dark"
              :src="imageData(dataModals.image)"
              @click="previewImagen(imageData(dataModals.image))"
              size="11rem"
              rounded
            ></b-avatar>
          </b-col>
          <b-col :md="7">
            <h2>
              <strong>{{ dataModals.title }}</strong>
            </h2>
            <p>{{ dataModals.body }}</p>
          </b-col>
          <b-col :md="12" class="p-2 ml-2">
            <span>{{ $t("name") }}: {{ dataModals.user.name }} {{ dataModals.user.lastname }}</span><br>
            <span>{{ $t("email") }}: {{ dataModals.user.email }}</span><br>
            <span>{{ $t("date") }}: {{ new Date(dataModals.created_at).toLocaleDateString() }}</span>
          </b-col>
        </b-row>

        <template #modal-footer>
          <b-button
            size="sm"
            variant="secondary"
            @click="$bvModal.hide('show-ticket')"
          >
            {{ $t("close") }}
          </b-button>
        </template>
      </b-modal>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { myRendeImage } from "@/directives/render-Image";

export default {
  props: {
    title: String,
  },
  mixins: [myRendeImage],
  async created() {
    await this.getData({
      currentPage: 1,
      perPage: this.perPage,
    });
    this.debouncedGetAnswer = _.debounce(this.search, 500);
  },
  watch: {
    searchData() {
      this.debouncedGetAnswer();
    },
    async perPage() {
      await this.changePerPage();
    },
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      searchData: "",
      dataModals: "",
    };
  },
  methods: {
    ...mapActions({
      getDataTickets: "tickets/getData",
    }),
    async search() {
      await this.getData({
        currentPage: this.currentPage,
        perPage: this.perPage,
        search: this.searchData,
      });
    },
    async changePage(value) {
      await this.getData({
        currentPage: value ? value : this.currentPage,
        perPage: this.perPage,
      });
    },
    async changePerPage() {
      await this.getData({
        currentPage: this.currentPage,
        perPage: this.perPage,
      });
    },
    async getData(data) {
      await this.getDataTickets(data);
    },
    modalsDetails(data) {
      this.dataModals = data;
      this.$bvModal.show("show-ticket");
    },
    previewImagen(image) {
      this.$viewerApi({
        images: [image],
      });
    },
  },
  computed: {
    ...mapGetters({
      tableData: "tickets/data",
    }),
    columns() {
      return [
        { label: this.$t("name"), key: "name", class: "text-center" },
        { label: this.$t("title"), key: "title", class: "text-center" },
        { label: this.$t("date"), key: "created_at", class: "text-center" },
        // { label: this.$t("actions"), key: "action", class: "text-center" },
        { label: this.$t("action"), key: "actions", class: "text-center" },
      ];
    },
  },
};
</script>